import fsaLogo from "~/hec/assets/images/fsastore_logo.svg";
import fsaLogoMobile from "~/hec/assets/images/fsastore_logo_mobile.svg";
import hsaLogo from "~/hec/assets/images/hsastore_logo.svg";
import hsaLogoMobile from "~/hec/assets/images/hsastore_logo_mobile.svg";
import wdhLogo from "~/hec/assets/images/welldeservedhealth_logo.svg";
import wdhLogoMobile from "~/hec/assets/images/welldeservedhealth_logo_mobile.svg";

// `src` is the desktop wordmark; `mobileSrc` is the 100×100 icon-only mark
// used at mobile breakpoints (mirrors SFRA `logoMobile.svg`). Optional so the
// header can fall back to the wordmark if a future site ships without one.
export type SiteLogo = { src: string; alt: string; mobileSrc?: string };

// Per-site logo assets. Keyed by siteCode ("hsa" | "fsa" | "wdh").
export const SITE_LOGOS: Record<"hsa" | "fsa" | "wdh", SiteLogo> = {
  hsa: { src: hsaLogo, alt: "HSA Store", mobileSrc: hsaLogoMobile },
  fsa: { src: fsaLogo, alt: "FSA Store", mobileSrc: fsaLogoMobile },
  wdh: { src: wdhLogo, alt: "Well Deserved Health", mobileSrc: wdhLogoMobile },
};
